import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxBigSpinnerComponent } from './ngx-big-spinner.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [NgxBigSpinnerComponent],
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  exports: [NgxBigSpinnerComponent]
})
export class NgxBigSpinnerModule { }
